export const INIT_CHAT = 'INIT_CHAT';




/** WEBPACK FOOTER **
 ** ./src/constants/ActionTypes.js
 **/